import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Container } from 'react-bootstrap';
import * as api from '~/Services/Service';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import FiltrosDebitos from './FiltrosDebitos';
import TabelaDebitos from './TabelaDebitos';

const RelatorioDebitos = () => {
  const [opcoes, setOpcoes] = useState(null);
  const [isLoadingOpcoes, setIsLoadingOpcoes] = useState(true);
  const [dados, setDados] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [contas, setContas] = useState([]);
  const [avisoData, setAvisoData] = useState('');

  useEffect(() => {
    const carregarOpcoes = async () => {
      try {
        const opcoesResp = await api.obterOpcoesDebitosCreditos();
        setOpcoes(opcoesResp);
        setContas(opcoesResp.contas || []);
      } catch {
        toast.error('Erro ao carregar opcoes.');
      } finally {
        setIsLoadingOpcoes(false);
      }
    };
    carregarOpcoes();
  }, []);

  const handleCorretorChange = async (codigoUsuario) => {
    if (!codigoUsuario) {
      if (opcoes) {
        setContas(opcoes.contas || []);
      }
      return;
    }
    try {
      const contasResp = await api.obterContasDebitosCreditos(codigoUsuario);
      setContas(contasResp || []);
    } catch {
      toast.error('Erro ao carregar contas do corretor.');
    }
  };

  const handleSubmit = async (values) => {
    setAvisoData('');

    if (!values.conta_portador || !values.grupo_empresa) {
      toast.error('Selecione uma conta para consulta.');
      return;
    }

    if (!values.data_inicial || !values.data_final) {
      toast.error('Informe as datas para a consulta.');
      return;
    }

    const formatarData = (dt) => {
      const d = new Date(dt);
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    };

    if (opcoes && values.data_inicial < formatarData(opcoes.data_trava)) {
      const dataTrava = new Date(opcoes.data_trava);
      const meses = ['janeiro','fevereiro','marco','abril','maio','junho',
        'julho','agosto','setembro','outubro','novembro','dezembro'];
      setAvisoData('Data inicial deve ser a partir de ' +
        meses[dataTrava.getMonth()] + ' de ' + dataTrava.getFullYear() +
        ' (data da penultima comissao gerada).');
      return;
    }

    setIsLoading(true);
    setDados(null);

    try {
      const filtros = {
        conta_portador: values.conta_portador,
        grupo_empresa: values.grupo_empresa,
        data_inicial: values.data_inicial,
        data_final: values.data_final,
      };

      const response = await api.consultarDebitosCreditos(filtros);

      if (!response || !response.itens || response.itens.length === 0) {
        toast.warning('Nao houve resultados para os filtros informados.');
        return;
      }

      setDados(response);
    } catch (err) {
      toast.error(err.message || 'Erro ao consultar debitos/creditos.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Debitos/Creditos" />

      {isLoadingOpcoes ? (
        <Loading label="Carregando opcoes..." />
      ) : opcoes && (
        <>
          <FiltrosDebitos
            onSubmit={handleSubmit}
            isLoading={isLoading}
            opcoes={opcoes}
            contas={contas}
            onCorretorChange={handleCorretorChange}
            avisoData={avisoData}
          />

          {isLoading && <Loading label="Carregando debitos e creditos..." />}

          {dados && (
            <TabelaDebitos dados={dados} />
          )}
        </>
      )}
    </Container>
  );
};

export default RelatorioDebitos;
